
import * as AbsintheSocket from '@absinthe/socket'
import { createAbsintheSocketLink } from '@absinthe/socket-apollo-link'
import { Socket as PhoenixSocket, LongPoll } from 'phoenix'

const SWITCH_PROTOCOL_TIMEOUT = 10000
const LAST_ONLINE_TIMEOUT = 20000

export const createtSocketLink = (socketUrl, emitter) => {
  // Socket with full fallback to LongPoll
  // via https://elixirforum.com/t/fall-back-to-longpoll-when-websocket-fails/23894
  const socket = new PhoenixSocket(socketUrl)
  let lastSwitch = 0
  let lastOnline = 0
  let didSuccessfullyConnect = false

  window.addEventListener('online', () => { lastOnline = +new Date() })

  socket.onError((a, b, c) => {
    const now = +new Date()
    const lastSwitchedRecently = now - lastSwitch < SWITCH_PROTOCOL_TIMEOUT
    const timeSinceOnline = now - lastOnline
    const lastOnlineRecently = didSuccessfullyConnect && timeSinceOnline < LAST_ONLINE_TIMEOUT

    emitter.emit('offline', {
      didSuccessfullyConnect,
      timeSinceOnline
    })

    if (navigator.onLine && !lastOnlineRecently && !lastSwitchedRecently) {
      const isWebSocket = socket.transport === window.WebSocket
      lastSwitch = now
      if (isWebSocket) {
        window.console && window.console.log('Switching protocol -> LP')
        socket.transport = LongPoll
      } else if (window.WebSocket) {
        window.console && window.console.log('Switching protocol -> WS')
        socket.transport = window.WebSocket
      }
    }
  })

  socket.onOpen(() => {
    emitter.emit('online', {
      reconnect: didSuccessfullyConnect,
      transport: socket.transport === window.WebSocket ? 'WS' : 'LP'
    })
    didSuccessfullyConnect = true
    lastOnline = +new Date()
  })

  const absintheSocket = AbsintheSocket.create(socket)

  return createAbsintheSocketLink(absintheSocket)
}
